import axios from "axios";
import React from "react";
import { useHistory } from "react-router-dom";
import { loadProfile } from "./utils/functions";
import { url } from "./utils/url";
const UserContext = React.createContext();
function ContextProvider({ children }) {
  const history = useHistory();
  // const firstPost = null;
  const defaultUser = {
    token: null,
    info: {},
  };
  const getUserFromLocalStorage = () => {
    return localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : defaultUser;
  };
  const syncUserToLocalStorage = (userToSync) => {
    localStorage.setItem("user", JSON.stringify(userToSync));
  };
  const [posts, setposts] = React.useState([]);
  const [topposts, settopposts] = React.useState([]);
  const [users, setusers] = React.useState([]);
  const [user, setuser] = React.useState(getUserFromLocalStorage);
  const [reload, setreload] = React.useState(true);
  const [loading, setloading] = React.useState(false);
  const [ended, setended] = React.useState(false);
  const [searchResults, setSearchResults] = React.useState({
    key: "",
    results: [],
  });
  React.useEffect(() => {
    loadPosts();
    loadUsers();
    loadUserinfo();
    gettopposts();
    // eslint-disable-next-line
  }, [reload]);

  let darkmode = localStorage.getItem("darkmode")
    ? JSON.parse(localStorage.getItem("darkmode"))
    : false;
  const [mode, setDarkMode] = React.useState(darkmode);
  const setMode = () => {
    if (mode) {
      localStorage.setItem("darkmode", false);
      setDarkMode(false);
    } else {
      localStorage.setItem("darkmode", true);
      setDarkMode(true);
    }
    darkmode = JSON.parse(localStorage.getItem("darkmode"));
  };

  React.useEffect(() => {
    document
      .querySelector('meta[name="theme-color"]')
      .setAttribute("content", mode ? "#000000" : "#ffffff");
  }, [mode]);

  const loadUserinfo = async () => {
    if (user.token) {
      let info = await loadProfile(user.token);
      let newUser = { ...user, info };
      setuser(newUser);
      syncUserToLocalStorage(newUser);
    }
  };
  const loadPosts = async () => {
    if (!loading) {
      setloading(true);
      let tempPosts = [];
      let tempEnded = ended;
      await axios
        .get(`${url}/api/posts/getpaginatedposts`, {
          params: { seenPosts: JSON.stringify(posts.map((post) => post._id)) },
        })
        .then((res) => {
          tempPosts = [...posts, ...res.data.data];
          tempEnded = res.data.ended;
        });
      if (tempPosts) {
        setposts(tempPosts);
        setended(tempEnded || false);
        // tempPosts.push("5fc75578020f110017e7ec0a");
        //   if (process.env.NODE_ENV === "production" && firstPost) {
        //     let firstPostToDisplay = {};
        //     tempPosts = tempPosts.filter((record) => {
        //       if (record._id === firstPost) {
        //         firstPostToDisplay = record;
        //       }
        //       return record._id !== firstPost;
        //     });
        //     tempPosts.push(firstPostToDisplay);
        //   }
        //   setposts(tempPosts.reverse());
      }
      setloading(false);
    }
  };

  async function gettopposts() {
    let response = await axios.get(`${url}/api/posts/gettopposts`, {
      // params: { seenPosts: JSON.stringify([]) },
      headers: {
        Authorization: `Bearer ${user?.token}`,
      },
    });
    if (response.data?.data) settopposts((p) => [...p, ...response.data.data]);
  }

  const prependPost = async (newPost) => {
    let response = await axios.get(`${url}/api/posts/getposts/${newPost._id}`);
    let tempPost = response.data.data;
    if (tempPost) {
      setposts([...posts, tempPost]);
    }
  };

  const loadUsers = async () => {
    let tempUsers = [];
    await axios.get(`${url}/api/auth/getUsers`).then((res) => {
      tempUsers = res.data.data;
    });
    if (tempUsers) {
      setusers(tempUsers);
    }
  };
  const loginUser = async (userData, action = "login") => {
    let link = action === "login" ? "/api/auth/login" : "/api/auth/register";
    let response;
    await axios
      .post(`${url}${link}`, userData)
      .then((res) => {
        response = res;
      })
      .catch((err) => {
        response = err.response;
      });
    response = response ? response : { data: {} };
    //sending request to the server and get user data (to be done)
    let finalUser = {};
    if (response.data.success) {
      finalUser = {
        token: response.data.token,
      };
      let info = await loadProfile(response.data.token);
      finalUser.info = info;
      setuser(finalUser);
      syncUserToLocalStorage(finalUser);
      let message =
        action === "login"
          ? "successifully logged in"
          : "successifully created account";
      return { message, success: true };
    } else {
      let { error } = response.data;
      return {
        success: false,
        error: error || "Error occured",
      };
    }
  };
  const logout = () => {
    setuser(defaultUser);
    // localStorage.clear();
    localStorage.removeItem("user");
  };
  const updateDetails = (newUser) => {
    let tempUser = {
      ...user,
      info: newUser,
    };
    setuser(tempUser);
    syncUserToLocalStorage(tempUser);
    setreload(!reload);
  };
  const reloadRequests = () => {
    setreload(!reload);
  };
  const searchHommies = async (searchKey) => {
    let tempResults = [];
    await axios.get(`${url}/api/auth/search?key=${searchKey}`).then((res) => {
      tempResults = res.data.data;
    });
    if (tempResults) {
      setSearchResults({
        key: searchKey,
        results: tempResults,
      });
      history.push("/search");
    }
  };
  let displayPosts = posts.map((post) => {
    let myLike = post.arrayOfFires?.find((item) => {
      return item === user.info?._id;
    });
    post.liked = myLike ? true : false;
    return post;
  });
  // reset passwords
  const resetPassword = async (query, email) => {
    try {
      let response = await axios.post(`${url}/api/mail/send?q=${query}`, email);
      console.log(response);
      return response.data;
    } catch (e) {
      console.log(e);
    }
  };
  // validate otp
  const validateOTP = async (body) => {
    try {
      let response = await axios.post(`${url}/api/auth/validate-otp`, body);
      return response.data;
    } catch (e) {
      console.log(e);
    }
  };

  const makeHommie = async (userId) => {
    try {
      let response = await axios
        .put(
          `${url}/api/auth/${userId}/hommies/add`,
          {},
          {
            headers: {
              Authorization: `Bearer ${user?.token}`,
            },
          }
        )
        .catch((err) => console.log(err));
      response = response.data;
      if (response.success) {
        let tempUser = { ...user };
        tempUser.info.followings = [
          ...new Set([...tempUser.info?.followings, userId]),
        ];
        setuser(tempUser);
        let tempPosts = [
          ...posts.map((post) => {
            if (post.author?._id === userId) {
              post.author.hommies = [
                ...new Set([...post.author?.hommies, user?.info?._id]),
              ];
            }
            return post;
          }),
        ];
        setposts(tempPosts);
      }
      return response;
    } catch (error) {
      return { success: false, error: error.response?.data?.message };
    }
  };

  const removeHommie = async (userId) => {
    try {
      let response = await axios
        .put(
          `${url}/api/auth/${userId}/hommies/remove`,
          {},
          {
            headers: {
              Authorization: `Bearer ${user?.token}`,
            },
          }
        )
        .catch((err) => console.log(err));
      response = response.data;
      if (response.success) {
        let tempUser = { ...user };
        tempUser.info.followings = [
          ...tempUser.info?.followings.filter(
            (following) => following._id === userId
          ),
        ];
        setuser(tempUser);
        let tempPosts = [
          ...posts.map((post) => {
            if (post.author?._id === userId) {
              post.author.hommies = [
                ...[
                  ...post.author?.hommies.filter(
                    (h) => h._id === user?.info?._id
                  ),
                ],
              ];
            }
            return post;
          }),
        ];
        setposts(tempPosts);
      }
      return response;
    } catch (error) {
      return { success: false, error: error.response?.data?.message };
    }
  };

  const deletePost = async (postId) => {
    try {
      let response = await axios
        .delete(
          `${url}/api/posts/deletepost/${postId}`,
          {
            headers: {
              authorization: `Bearer ${user.token}`,
            },
          },
          {
            headers: {
              Authorization: `Bearer ${user?.token}`,
            },
          }
        )
        .catch((err) => console.log(err));
      response = response.data;
      if (response.success) {
        let tempPosts = posts.filter((post) => post._id !== postId);
        setposts(tempPosts);
        window.Toast.fire({
          icon: "success",
          title: response.message || "Post Successfully deleted",
        });
      } else {
        if (response.message) {
          window.Toast.fire({
            icon: "error",
            title: response.message,
          });
        }
      }
    } catch (error) {
      if (error.response?.data?.message)
        window.Toast.fire({
          icon: "error",
          title: error.response?.data?.message,
        });
    }
  };

  // change password
  const changePassword = async (action, body) => {
    try {
      let response = await axios.post(
        `${url}/api/auth/changepassword?q=${action}`,
        { old_password: body.old_password, new_password: body.new_password },
        {
          headers: {
            authorization: `Bearer ${body.token}`,
          },
        }
      );
      return response.data;
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <UserContext.Provider
      value={{
        user,
        loginUser,
        loadPosts,
        deletePost,
        prependPost,
        logout,
        loading,
        posts: displayPosts,
        topposts: topposts,
        ended,
        updateDetails,
        reloadRequests,
        users,
        searchHommies,
        makeHommie,
        removeHommie,
        searchResults,
        setMode,
        mode,
        resetPassword,
        validateOTP,
        changePassword,
      }}
    >
      {children}
    </UserContext.Provider>
  );
}
export default UserContext;
export { ContextProvider };
